import React from "react";

function DepositNotice({ children }) {
  // ✅ Cleaned up dead commented-out code. Pass children to customize notice content.
  if (!children) return null;
  return (
    <div className="ng-trigger ng-trigger-slideAnimation ng-star-inserted">
      <div className="tips-info verify-tips tips-info-toggle ng-star-inserted">
        <div className="title-box">
          <h5>
            <i className="tips-icon" style={{maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-tips-type02.svg?v=1729676340443")'}} />
            <span>{children}</span>
          </h5>
        </div>
      </div>
    </div>
  );
}
export default DepositNotice;